import { createAsyncAction } from 'typesafe-actions';
import { Country } from '@rootCommon/types/glossary';

export const fetchCountries = createAsyncAction(
  'FETCH_COUNTRIES_REQUEST',
  'FETCH_COUNTRIES_SUCCESS',
  'FETCH_COUNTRIES_FAILURE',
)<undefined, Country[], Error>();

export default fetchCountries;
